import React from 'react';
import LocalFileExtractor from '../components/LocalFileExtractor';

const ExtractPage = () => {
  return (
    <div className="tool-page">
      <div className="page-header">
        <h1>🔓 Extract Password‑Protected ZIP</h1>
        <p className="subtitle">
          Safely extract encrypted archives. Select a protected ZIP, enter the password, and get
          your files — locally, without uploading to a server.
        </p>
      </div>
      <section className="tool-card">
        <LocalFileExtractor />
      </section>
    </div>
  );
};

export default ExtractPage;
